// TODO: BUG: fix dependency cycle with content
import type { IContentModel } from '~/features-shared/content/interfaces/content-model'
// TODO: BUG: fix dependency cycle with experience
import type { ExperienceName } from '~/features-shared/experience/interfaces/experience'

export enum FacetType {
  CONTENT_TYPE,
  EXPERIENCE,
}

// Response
// TODO: ENH: refactor comments
export interface FacetResponse {
  uri: string // ALWAYS, request: only for update
  resource_id: string | null // -> resource_id ALWAYS
  resource_name: string | null // -> resource_name ALWAYS

  community: {
    id: string
    subject6wuri: string
    title: string
  }

  //
  /**
   * response -> ALWAYS
   * request -> ONLY FOR CUSTOM
   * //
   * On UI side, need to display default experience label IF resourceId && resourceName is NULL
   */
  label: string // ALWAYS -> request: MANDATORY FOR CUSTOM, NOT NECESSARY FOR NATIVE
  position: number // ALWAYS, request: NOT SENT
  icon: string | null // ALWAYS, request: only for custom
  color: string | null // ALWAYS, request: only for custom

  //
  native: boolean // ALWAYS, request: NEVER
  type: string // ALWAYS

  //
  service_name: string | null // ALWAYS, request: not updatable once set
  app_id: string | null // ALWAYS, request: not updatable once set
  config?: string // only for community/URI/facet/ID, request: only if it set

  //
  enabled: boolean // ALWAYS

  //
  creation_date: string // ALWAYS, request read-only
  modification_date: string // ALWAYS, request read-only
}

/**
 * Facet interface expected by the backend.
 */
export interface FacetDTO {
  /**
   * The facet URI.
   * @info Mandatory for update.
   */
  uri?: string
  /**
   * The facet type.
   * Content type or Experience type.
   * @example post, project.
   */
  type: string
  /**
   * True if the facet is enabled in the community.
   */
  enabled: boolean
  /**
   * The ID of the resource attached to the facet.
   * @info Only for Experience.
   */
  resource_id?: string | null
  /**
   * The name of the resource attached to the facet.
   * @info Only for Experience.
   */
  resource_name?: string | null
  /**
   * The default ID of the app that will be launched for the facet.
   * @info Mandatory for creation.
   * @info Only for Experience.
   */
  app_id?: string
  /**
   * The service name related to the app that will be launched for the facet.
   * @info Mandatory for creation.
   * @info Only for Experience.
   */
  service_name?: string
  /**
   * The facet configuration (widget preferences for the app).
   * @info Only for Experience.
   */
  config?: string
  /**
   * The facet label.
   * @info Only for Experience.
   */
  label?: string
  /**
   * The facet icon.
   * @info Only for Experience.
   */
  icon?: string
  /**
   * The facet icon color.
   * @info Only for Experience.
   */
  color?: string
}

interface Facet {
  communityUri?: string // No community URI in creation
  uri?: string // No URI in creation
  tempUri?: string // For new facets
  type: FacetType
  position: number // TODO: To remove
  enabled: boolean
}

export interface FacetContentType extends Facet {
  type: FacetType.CONTENT_TYPE
  model: IContentModel
}

// TODO: ENH: refactor, same properties with Experience
export interface FacetExperience extends Facet {
  type: FacetType.EXPERIENCE
  experience: ExperienceName

  label: string
  icon: string
  color: string

  serviceName: string
  appId: string

  resourceId?: string
  resourceName?: string

  widgetPreference?: string
}

export type FacetUnion = FacetContentType | FacetExperience

export interface IFacetSetting {
  /** Facet URI */
  uri?: string
  /** Facet temporary URI, for new facets */
  tempUri?: string

  type: FacetType
  isEnabled: boolean
  disableIsEnabledEdition: boolean
  order: number
}
